/**
 * @function assetImport
 * @param {string} id id to import
 * @param {string} theme theme to import from
 * @description Uses require to import from assets or themes
 * @returns {string} import
 */
//TODO:: replace with useAsset and remove this file
const assetImport = (id: string, theme?: string): any => {
  const asset = require(`../assets/${id.substr(7)}`);
  return asset.default;
};

export default assetImport;
